import React from 'react';
import { SlideContainer } from '../SlideContainer';
import { FadeInStagger, FadeIn } from '../FadeIn';
export const Slide06Value = () => {
  const profValue = ['Individual student reports with dimensional scoring', 'Cohort-level analytics showing preparation quality and knowledge gaps', 'Pre-class signals: who actually did the reading and thought about it', 'Configurable rubrics aligned to course learning objectives', 'Scalable verification without increasing TA workload'];
  const studentValue = ['Practice as many times as they want with coaching feedback', 'Immediate, specific feedback on reasoning quality', 'Low-stakes environment to prepare before high-stakes participation', 'Available anytime, on any device', 'Engaging and fluid, not a quiz or a form'];
  return <SlideContainer data-id="element-147">
      <FadeInStagger data-id="element-148">
        <FadeIn data-id="element-149">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-white mb-16" data-id="element-150">
            Built for both sides of the classroom
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-151">
          <FadeIn data-id="element-152">
            <div data-id="element-153">
              <h3 className="text-2xl font-semibold text-white mb-8 pb-4 border-b border-white/10" data-id="element-154">
                What the Professor Gets
              </h3>
              <ul className="space-y-6" data-id="element-155">
                {profValue.map((item, i) => <li key={i} className="flex items-start" data-id="element-156">
                    <span className="text-accent-purple mr-4 mt-1.5 opacity-70" data-id="element-157">
                      ✦
                    </span>
                    <span className="text-lg text-white/70 leading-relaxed" data-id="element-158">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn data-id="element-159">
            <div data-id="element-160">
              <h3 className="text-2xl font-semibold text-white mb-8 pb-4 border-b border-white/10" data-id="element-161">
                What the Student Gets
              </h3>
              <ul className="space-y-6" data-id="element-162">
                {studentValue.map((item, i) => <li key={i} className="flex items-start" data-id="element-163">
                    <span className="text-accent-blue mr-4 mt-1.5 opacity-70" data-id="element-164">
                      ✦
                    </span>
                    <span className="text-lg text-white/70 leading-relaxed" data-id="element-165">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </FadeInStagger>
    </SlideContainer>;
};